import { el } from '../modules/formEl.js';
import { errors } from '../modules/formElErrors.js';
import { redirects } from '../modules/formRedirects.js';
import '../vendor/select2.min.js';

var form = {},
	busy = false;

function ajax($form, cb) {
	if (busy == false) {
		busy = true;
		//let data = $form.serialize();
		let data = new FormData($form[0]);
		$form.find('.field').find('input, textarea').attr('disabled', true);
		$form.find('.field-submit').addClass('has-loader');
		$form.addClass('loading');
		$.ajax({
			method: 'POST',
			url: customData.ajaxURL,
			data: data,
			async: true,
			cache: false,
			dataType: 'json',
			contentType: false,
			processData: false
		}).done(function (response) {
			busy = false;
			cb(response);
		});
	}
}

function controller($form) {
	errors.check.form($form, function (error) {
		if (error == false) {
			ajax($form, function (response) {

				if (typeof response.success != 'undefined' && response.success == true) {
					errors.formNotice($form, false, true, response.data.message, response.data.message_position);
					$form.addClass('done');
					redirects.do($form, response);
				} else {
					$form.find('.field').find('input, textarea').attr('disabled', false);
					errors.formNotice($form, true, true, response.data.message);
					for (let name in response.data.errors) {
						let message = response.data.errors[name],
							$this = $form.find('.field').find('input[name="' + name + '"], textarea[name="' + name + '"], select[name="' + name + '"]').parents('.field');
						errors.check.elPHP($this, message);
					}
				}
				$form.find('.field-submit').removeClass('has-loader');
				$form.removeClass('loading');
			});
		}
	});
}

form.init = function () {
	el.init();
	$('.form-validation').submit(function (e) {
		if (!$(this).hasClass('done')) {
			e.preventDefault();
			// console.log(this);
			controller($(this));
		}
	});


	$('.select2').select2({
		dropdownAutoWidth: true,
		minimumResultsForSearch: Infinity,
		allowClear: false,
	});


}

export { form };
